import { Link } from '@cian/ui-kit/link';
import type { MouseEvent } from 'react';

import { OFFERS_PROPERTY_TYPES } from 'shared/constants/buildingLabels';
import type { TOffersPropertyType } from 'shared/types/buildingOffers';

import style from './style.css';

export interface IOffersAnchorsProps {
  propertyTypes: TOffersPropertyType[];
  onSelect(propertyType: TOffersPropertyType): void;
}

/** Якоря категорий предложений в основном блоке (`anchor_list.tsx` монолита), без счётчиков */
export const OffersAnchors = ({ propertyTypes, onSelect }: IOffersAnchorsProps) => {
  if (!propertyTypes.length) {
    return null;
  }

  const handleClick = (event: MouseEvent<HTMLAnchorElement>, propertyType: TOffersPropertyType) => {
    event.preventDefault();
    onSelect(propertyType);
  };

  return (
    <nav className={style['container']} data-name="OffersAnchors">
      {OFFERS_PROPERTY_TYPES.filter(({ type }) => propertyTypes.includes(type)).map(({ type, label }) => (
        <Link key={type} href="#all-offers" fontSize="S" onClick={event => handleClick(event, type)}>
          {label}
        </Link>
      ))}
    </nav>
  );
};
